/* @pareto-engineering/generator-front 1.1.1-alpha.1 */
import * as React from 'react'

/**
 * This is the component description (copied from apps/triage).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    // Don't call this.setState() here!
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.log(error, info)
  }

  render() {
    const { children, fallback } = this.props
    const { error } = this.state
    if (error) {
      if (typeof fallback === 'function') {
        return fallback({ error })
      }
      return fallback
    }
    return children
  }
}

export default ErrorBoundary
